module.exports = __webpack_public_path__ + "img/Artboard 55.eae0c85b.png";